import { connect } from 'react-redux';
import { getSettings } from '../../selectors/settings';
import { getConvo, getBanners } from '../../selectors/conversation';
import { hideBanner } from '../../actions';
import { RootState } from '../../typedefs/store';
import Banner from './Banner';

const mapStateToProps = (state: RootState, ownProps: any) => {
    const settings = getSettings(state);
    const convo = getConvo(state);
    return {
        banners: getBanners(state),
        shouldShow: !settings.hideBanner && !convo.ended,
    };
};

const mapDispatchToProps = { hide: hideBanner };

export default connect(mapStateToProps, mapDispatchToProps)(Banner);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/BannerContainer.tsx